module.exports = __webpack_public_path__ + "img/ads4.f2fd51b.webp";